// gatsby-browser.js
import "bootstrap/dist/css/bootstrap.min.css"
import "./src/styles/global.scss"

// Scroll to top on page navigation
export const onRouteUpdate = () => {
  window.scrollTo(0, 0)
}
